import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material'
import React from 'react'

const WeekBasedTable = ({displayedVehicles, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage}) => {

    const handleSelectedRowWeek = (data) => {
        localStorage.setItem("rowDataWeek", JSON.stringify(data))
        window.open("/live-tracking/weekdetailreport")
    }
    
    return (
        <div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow
                            sx={{
                                "& th": {
                                    fontWeight: "bold",
                                    fontSize: "17px"
                                }
                            }}
                        >
                            <TableCell>S.No.</TableCell>
                            <TableCell>Service ID</TableCell>
                            <TableCell>Service Name</TableCell>
                            <TableCell>Vehicle No</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>End Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedVehicles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                            <TableRow key={data.jobId} onClick={() => handleSelectedRowWeek(data)}>
                                <TableCell>{index + 1 + (page * rowsPerPage)}</TableCell>
                                <TableCell>{data.serviceID}</TableCell>
                                <TableCell>{data.serviceName}</TableCell>
                                <TableCell>{data.vehicleNo}</TableCell>
                                <TableCell>{data.from}</TableCell>
                                <TableCell>{data.to}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={displayedVehicles.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[20, 30, 40, 50]}
                    labelRowsPerPage="Rows per page"
                />
            </TableContainer>
        </div>
    )
}

export default WeekBasedTable